/**
 * Internal / QA emails that must not enter Google Ads, Meta CAPI, or Loops marketing.
 * Keep in sync with move-club-backend-main/src/constants/internalTestEmails.ts
 *
 * Payments still succeed for these addresses.
 */
export const INTERNAL_TEST_EMAIL_EXACT = [
    'creativeuser141@gmail.com',
] as const;

export const INTERNAL_TEST_EMAIL_DOMAINS = [
    'example.com',
    'move-club.co',
    'reaction-club.com',
    'getwemove-verify.com',
] as const;

const PLUS_GMAIL_PREFIX = 'malka.yonatan+';

export function isInternalTestEmail(email: string | undefined | null): boolean {
    if (!email || typeof email !== 'string') {
        return false;
    }

    const normalizedEmail = email.toLowerCase().trim();
    if (!normalizedEmail.includes('@')) {
        return false;
    }

    if (INTERNAL_TEST_EMAIL_EXACT.includes(normalizedEmail as (typeof INTERNAL_TEST_EMAIL_EXACT)[number])) {
        return true;
    }

    const atIndex = normalizedEmail.lastIndexOf('@');
    const localPart = normalizedEmail.slice(0, atIndex);
    const domainPart = normalizedEmail.slice(atIndex + 1);

    if (INTERNAL_TEST_EMAIL_DOMAINS.includes(domainPart as (typeof INTERNAL_TEST_EMAIL_DOMAINS)[number])) {
        return true;
    }

    if (domainPart === 'gmail.com' && localPart.startsWith(PLUS_GMAIL_PREFIX)) {
        return true;
    }

    return false;
}
